export { default as NoticeDetail } from "./NoticeDetail";
export { default as NoticeList } from "./NoticeList";

